/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=09e0dad0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=09e0dad0&lang=less&scoped=true"
import "./index.vue?vue&type=style&index=1&id=09e0dad0&lang=css"

import exportComponent from "/home/jenkins/agent/workspace/yunxiaobao-test/test-huodada-com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09e0dad0"]])

export default __exports__